<template>
    <div class="mt-4 mb-2 ml-0">
        <div class="layout row mb-2">
            <div class="font-weight-medium mr-1 width-200">
                Date:
            </div>
            <div>{{ row.date | time }}</div>
        </div>

        <div class="layout row mb-2" v-for="prop in getRowProperties()">
            <div class="font-weight-medium mr-1 width-200">
                {{ prop.name }}:
            </div>
            <div>{{ prop.value }}</div>
        </div>

        <div class="mt-5" v-if="details">
            <div
                class="font-weight-medium mb-2 layout row"
                style="border-bottom: 1px solid #999;"
            >
                Details
            </div>
            <div
                class="layout row mb-2"
                v-for="detail in details"
                v-if="details"
            >
                <div class="font-weight-medium mr-1">
                    {{ detail.description }}:
                </div>
                <div>{{ detail.amount | currency }}</div>
            </div>
        </div>

        <div>
            <v-btn
                small
                dark
                color="success"
                class="mt-3"
                @click="openTransactionDialog"
                >Update Transaction</v-btn
            >
        </div>

        <v-divider class="mt-3"></v-divider>

        <div>
            <v-btn
                small
                dark
                color="success"
                class="mt-4"
                @click="openUploadDocument"
                >Upload Document<v-icon right dark
                    >mdi-cloud-upload</v-icon
                ></v-btn
            >
        </div>

        <div class="mt-3" v-if="documents && documents.length">
            <div class="font-weight-medium mb-0 layout row">
                Documents
            </div>
            <v-layout column>
                <div v-for="transactionDocument in documents">
                    <v-btn
                        class="mt-2 ml-0 px-3"
                        @click="openDocument(transactionDocument)"
                    >
                        <v-icon color="red" left dark>mdi-file-pdf</v-icon>
                        <span class="font-weight-medium mr-2">{{
                            transactionDocument.type
                        }}</span>
                        {{
                            transactionDocument.description +
                                " - " +
                                transactionDocument.uploadedOn
                        }}
                        <v-icon right>mdi-download</v-icon>
                    </v-btn>
                    <v-btn
                        small
                        icon
                        @click.stop="deleteDocument(transactionDocument)"
                        ><v-icon color="red">mdi-delete-forever</v-icon></v-btn
                    >
                </div>
            </v-layout>
        </div>

        <v-dialog v-model="uploadDocumentDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Upload Document</v-card-title>
                <v-combobox
                    class="px-3"
                    autocomplete="new-password"
                    :items="documentTypes"
                    label="Type"
                    v-model="uploadDocument.type"
                    ref="documentType"
                ></v-combobox>
                <v-text-field
                    class="px-3"
                    autocomplete="new-password"
                    label="Description"
                    v-model="uploadDocument.description"
                ></v-text-field>
                <v-layout row>
                    <v-btn
                        small
                        outline
                        class="mr-2 ml-3 mb-4 mt-0"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <div v-if="files.length" class="mt-2 ml-2">
                        {{ files[0].name }}
                    </div></v-layout
                >
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept="image/*,.pdf"
                    @change="onFilePicked($event)"
                />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeUploadDocumentDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!files.length"
                        :loading="processing"
                        color="success"
                        @click="saveDocument()"
                    >
                        Save Document
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateTransactionDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Update Transaction</v-card-title>
                <div style="overflow-y: auto; height: 600px">
                    <v-menu
                        v-model="transactionToEdit.datePickerMenu"
                        :close-on-content-click="true"
                        offset-y
                        full-width
                        prepend-icon="mdi-currency-usd"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                class="px-3"
                                v-model="transactionToEdit.date"
                                :value="transactionToEdit.date"
                                label="Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="transactionToEdit.date"
                        ></v-date-picker>
                    </v-menu>
                    <v-select
                        class="px-3"
                        :items="['Debit', 'Credit']"
                        label="Type"
                        v-model="transactionToEdit.type"
                        ref="type"
                    ></v-select>
                    <v-combobox
                        class="px-3"
                        label="Category"
                        :items="transactionCategories"
                        v-model="transactionToEdit.category"
                    ></v-combobox>
                    <v-text-field
                        class="px-3"
                        label="Description"
                        v-model="transactionToEdit.description"
                    ></v-text-field>
                    <v-text-field
                        class="px-3"
                        type="number"
                        label="Amount"
                        v-model="transactionToEdit.amount"
                    ></v-text-field>
                    <v-combobox
                        class="px-3"
                        label="Payment Method"
                        :items="paymentMethods"
                        v-model="transactionToEdit.paymentMethod"
                    ></v-combobox>
                    <v-select
                        class="px-3"
                        label="Card Type"
                        :items="['Visa', 'Amex']"
                        v-model="transactionToEdit.cardType"
                    ></v-select>
                    <v-text-field
                        class="px-3"
                        label="Card Ending"
                        v-model="transactionToEdit.cardEnding"
                    ></v-text-field>
                    <v-text-field
                        class="px-3"
                        label="Check Number"
                        v-model="transactionToEdit.checkNumber"
                    ></v-text-field>
                    <v-text-field
                        class="px-3"
                        label="Reference Number"
                        v-model="transactionToEdit.referenceNumber"
                    ></v-text-field>
                    <div v-for="(detail, index) in detailsToEdit" class="my-2">
                        <v-layout row class="px-3">
                            <v-text-field
                                class="mr-2 mt-0 pt-0"
                                label="Description"
                                v-model="detail.description"
                            ></v-text-field>
                            <v-text-field
                                class="mt-0 pt-0"
                                label="Amount"
                                type="number"
                                v-model="detail.amount"
                            ></v-text-field>

                            <v-btn
                                class="mt-0"
                                @click="addDetail(detailsToEdit)"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn
                                class="mt-0"
                                @click="removeDetail(detailsToEdit, index)"
                                flat
                                icon
                                color="#f55a4e"
                            >
                                <v-icon>mdi-minus-circle-outline</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-divider
                            class="pt-3 pb-1"
                            v-if="index + 1 < detailsToEdit.length"
                            :key="index"
                        ></v-divider>
                    </div>
                </div>
                <v-card-actions class="mr-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateTransactionDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            details: [],
            documents: [],
            processing: false,
            uploading: false,
            uploadDocumentDialog: false,
            documentTypes: [""],
            paymentMethods: [],
            transactionCategories: [],
            files: [],

            uploadDocument: {
                description: "",
                type: "",
            },

            updateTransactionDialog: false,
            transactionToEdit: "",
            detailsToEdit: [],

            email: "",

            emailRules: [
                (value) => !!value || "Required.",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            ],
        };
    },
    async created() {
        await this.loadDetails();
        await this.loadDocumentTypes();
        await this.loadTransactionCategories();
        await this.loadPaymentMethods();
    },
    computed: {},
    methods: {
        async loadDetails() {
            const id = this.row.id;

            const response = await this.$http.get(
                "api/transactions/getDetails?id=" + id
            );

            this.details = response.details;
            this.documents = response.documents.map((d) => {
                d.uploadedOn = moment(d.uploadedOn).format(
                    "MM/DD/YYYY h:mm:ss A"
                );

                return d;
            });
        },
        async loadDocumentTypes() {
            this.documentTypes = await this.$http.get(
                "api/transactions/getDocumentTypes"
            );
        },
        async loadPaymentMethods() {
            this.paymentMethods = await this.$http.get(
                "api/transactions/getPaymentMethods"
            );
        },
        async loadTransactionCategories() {
            this.transactionCategories = await this.$http.get(
                "api/transactions/getTransactionCategories"
            );
        },
        getRowProperties() {
            return Object.keys(
                except(
                    this.row,
                    "date",
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended"
                )
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: this.row[key],
                    };
                })
                .filter((p) => p.value);
        },
        openTransactionDialog() {
            this.transactionToEdit = JSON.parse(JSON.stringify(this.row));
            this.detailsToEdit = JSON.parse(JSON.stringify(this.details));

            if (this.detailsToEdit.length == 0) {
                this.addDetail(this.detailsToEdit);
            }

            this.transactionToEdit.datePickerMenu = false;
            this.transactionToEdit.date = new Date(this.transactionToEdit.date)
                .toISOString()
                .substr(0, 10);

            this.updateTransactionDialog = true;
        },
        addDetail(details) {
            if (!details) {
                details = [];
            }
            details.push({
                id: 0,
                description: "",
                amount: "",
            });

            this.$forceUpdate();
        },
        removeDetail(details, index) {
            if (index == 0) {
                this.detailsToEdit[0].description = "";
                this.detailsToEdit[0].amount = "";
            }

            this.detailsToEdit.splice(index, 1);
            this.$forceUpdate();
        },
        async save() {
            const data = this.transactionToEdit;

            this.processing = true;

            await this.$http.post("api/transactions/save", {
                transaction: data,
                details: this.detailsToEdit
                    .filter((d) => d.description)
                    .map((detail) => {
                        detail.transactionId = this.row.id;

                        return detail;
                    }),
            });

            this.processing = false;
            this.updateTransactionDialog = false;
            this.reloadGrid();
            this.loadDetails();
        },
        openUploadDocument() {
            this.uploadDocumentDialog = true;
        },
        closeUploadDocumentDialog() {
            this.uploadDocumentDialog = false;
            this.files = [];
        },
        openDocument(document) {
            window.open(document.url);
        },
        deleteDocument(document) {},
        pickFile() {
            this.$refs.files.click();
        },

        async onFilePicked(e, student) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            this.uploading = false;
        },
        async saveDocument() {
            // if (
            //     !this.$refs.documentType.validate(true) ||
            //     (Array.isArray(this.documentType) && !this.documentType.length)
            // ) {
            //     this.$notify({
            //         group: "notification",
            //         text: "Missing Document Type",
            //         type: "error",
            //     });

            //     return;
            // }

            this.processing = true;

            try {
                var formData = new FormData();

                formData.append("image", this.files[0]);

                await this.$http.post(
                    "api/transactions/uploadDocument?transactionID=" +
                        this.row.id +
                        "&description=" +
                        this.uploadDocument.description +
                        "&type=" +
                        this.uploadDocument.type +
                        "&propertyID=" +
                        this.row.propertyId +
                        "&user=" +
                        this.$store.state.user,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                this.processing = false;
                this.uploadDocumentDialog = false;
                this.files = [];
                this.loadDetails();
                //this.documentType = [];

                //this.refresh();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.dinner-ivr-detail-text {
    font-size: 16px;
    font-weight: 400;
}
</style>
